export default __webpack_public_path__ + "static/media/City-driver-pana.5a851e50.svg";